import * as React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import {BonusProgressBar} from '/component/base/BonusProgressBar';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './EarnedCoachAcceleratorBonusReportContent.style';
interface BonusHistoryItem {
  newOrderingEntities: number;
  earnedOn: string;
  earnedBonusAmount: number;
}
interface Props {
  recordData: {
    bonusHistory?: BonusHistoryItem[];
    eligibleEndDate?: string | null;
  };
}

export const EarnedCoachAcceleratorBonusReportContent: React.FC<Props> = ({
  recordData,
}) => {
  const dateUtil = getDateUtilDefaultInstance();
  const bonusHistory = get(recordData, 'bonusHistory', []);
  const eligibleEndDate = get(recordData, 'eligibleEndDate', null);

  const {tt} = useTranslation('reportCardContent.earnedAccelerator');

  const currentBonusEndDate = eligibleEndDate
    ? dateUtil.getLastDayOfPreviousMonth(eligibleEndDate)
    : null;

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading" testID={CoachInfoCard.earnedABTitle}>
            {tt('title', 'Earned Coach Accelerator Bonus')}
          </Text>
        </Gutter>
      </View>
      {bonusHistory?.map(
        ({newOrderingEntities, earnedOn, earnedBonusAmount}, index) => (
          <Gutter key={index}>
            <View style={styles.bonusProgressBar}>
              <BonusProgressBar
                newOrderingEntities={newOrderingEntities}
                currentDate={earnedOn}
                earnedBonusAmount={earnedBonusAmount}
                isEarnedBonusCard
                currentBonusEndDate={currentBonusEndDate}
              />
            </View>
          </Gutter>
        ),
      )}
    </View>
  );
};
